"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var notes_controller_1 = __importDefault(require("./notes.controller"));
var notes_html_1 = __importDefault(require("./notes.html"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.student.notes", {
        url: "/notes",
        controller: notes_controller_1.default,
        controllerAs: "vm",
        template: notes_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.student,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("student.notes", [])
    .config(config)
    .controller("StudentNotesController", notes_controller_1.default);
